import React, { Component } from 'react'
import { autorun } from 'mobx'
import { inject, observer } from 'mobx-react'
import ReactTooltip from 'react-tooltip'

import IndexPage from '../components/IndexPage'
import StoreShape from '../../../shared/store-proptypes'

@inject('item') @observer
export default
class IndexPageContainer
  extends Component {

  static propTypes = {
    item: StoreShape.isRequired
  }

  componentDidMount() {
    this.handler = autorun(() => {
      this.props.item.collection.length
      window.setTimeout(() => {
        ReactTooltip.rebuild()
      }, 10)
    })
    if (!this.props.item.loading) {
      this.props.item.load(null, {
        params: {
          size: 3 * 6 * 2
        }
      })
    }
  }

  componentWillUnmount() {
    if (this.handler) {
      this.handler()
    }
  }

  render() {
    return (
      <IndexPage
        item={this.props.item}
      />
    )
  }

}



// WEBPACK FOOTER //
// ./src/frontend/base/containers/IndexPage.js